import { API_URLS } from '../constants/apiUrls';
import { IAddCrewRequest } from '../type/addCrew';
import { AddDriver } from '../type/addDriver';
import { IDutyManagerRequest } from '../type/addDutyManager';
import { IAddTOflRequest } from '../type/addOflTimeRequest';
import { IAddPilot } from '../type/addPilot';
import { IAddTemperatureRequest } from '../type/addTemp';
import { ICancelFlight } from '../type/cancelFlight';
import { EditFlightForm } from '../type/editFlightForm';
import { IOperationsForecastRequest } from '../type/IOperationsForecastRequest';
import { IFLightWeatherInfo } from '../type/flightWeather';
import axiosClient from './axiosClient';
import { IUpdateComments } from '../type/updateComment';
import { IFlightCancelReactivateRequest } from '../type/flightCancelReactivateRequest';
import { IUpdateResPhone } from '../type/addRes';

const operationAPI = {
  addDriver: (data: AddDriver) => {
    return axiosClient.post(`${API_URLS.ADD_DRIVER}`, data);
  },
  getOperationDetails: (ownerId: number, date: string, time: string) => {
    date = date;
    return axiosClient.get(
      `${API_URLS.GET_OPERATION_DETAILS}?ownerId=${ownerId}&toDate=${date}&time=${time}`,
    );
  },
  getStaffAllocation: (ownerId: number, encodedDate: string) => {
    return axiosClient.get(
      `${API_URLS.GET_STAFF_ALLOCATION}?ownerId=${ownerId}&fromDate=${encodedDate}`,
    );
  },
  getLocationList: () => {
    return axiosClient.get(`${API_URLS.GET_LOCATION_LIST}`);
  },
  googleDriverImage: (
    date: string,
    googleDriverLink: string,
    ownerId: number,
  ) => {
    return axiosClient.post(`${API_URLS.POST_IMAGE_URL}`, {
      date: date,
      googleDriverLink: googleDriverLink,
      ownerId: ownerId,
    });
  },
  driverList: (ownerId: number, date: string) => {
    return axiosClient.get(
      `${API_URLS.DRIVER_LIST}?ownerId=${ownerId}&toDate=${date}`,
    );
  },
  pilotList: (ownerId: number, date: Date) => {
    return axiosClient.get(
      `${API_URLS.PILOT_LIST}?ownerId=${ownerId}&toDate=${date}`,
    );
  },
  crewList: (ownerId: number, date: string) => {
    return axiosClient.get(
      `${API_URLS.CREW_LIST}?ownerId=${ownerId}&toDate=${date}`,
    );
  },
  updateDriver: (data: AddDriver) => {
    return axiosClient.put(`${API_URLS.UPDATE_DRIVER}`, data);
  },
  addPilot: (data: IAddPilot) => {
    return axiosClient.post(`${API_URLS.ADD_PILOT}`, data);
  },
  actionedOperationCheckList: (
    bookingProductId: number,
    operationTriggerId: number,
    actioned: number,
    staffId: number | undefined,
  ) => {
    return axiosClient.post(`${API_URLS.BOOKING_CHECKLIST_ACTIONED}`, {
      bookingProductId,
      operationTriggerId,
      actioned,
      staffId,
    });
  },
  totalBookingsZoneWise: (ownerId: number, date: string) => {
    return axiosClient.get(
      `${API_URLS.TOTAL_BOOKING_ZONE_WISE}?toDate=${date}&ownerId=${ownerId}`,
    );
  },
  addCrew: (data: IAddCrewRequest) => {
    return axiosClient.post(`${API_URLS.ADD_CREW}`, data);
  },
  updateCrew: (data: IAddCrewRequest) => {
    return axiosClient.put(`${API_URLS.UPDATE_CREW}`, data);
  },
  updatePilot: (data: IAddPilot) => {
    return axiosClient.put(`${API_URLS.UPDATE_PILOT}`, data);
  },
  googleMap: (ownerId: number, date: string) => {
    return axiosClient.get(
      `${API_URLS.GOOGLE_MAP_BOOKINGS_DETAILS}?toDate=${date}&ownerId=${ownerId}&fromDate=${date}`,
    );
  },
  addDutyManager: (data: IDutyManagerRequest) => {
    return axiosClient.post(API_URLS.ADD_DUTY_MANAGER_PIC, data);
  },
  addTemperature: (data: IAddTemperatureRequest) => {
    return axiosClient.post(`${API_URLS.ADD_TEMP}`, data);
  },
  staffDetails: (operationStaffId: number) => {
    return axiosClient.get(
      `${API_URLS.STAFF_DETAILS}?operationStaffId=${operationStaffId}`,
    );
  },
  calendarDetails: (ownerId: number, date: string) => {
    return axiosClient.get(
      `${API_URLS.CALENDER_DETAILS_HEADER}?ownerId=${ownerId}&fromDate=${date}&toDate=${date}`,
    );
  },
  deleteStaff: (
    operationStaffId: number | undefined,
    operationBalloonId?: number | null| undefined |"undefined",
  ) => {
    if (operationBalloonId === 'undefined') operationBalloonId = null;
    return axiosClient.get(
      `${API_URLS.DELETE_STAFF}?operationStaffId=${operationStaffId}&operationBalloonId=${operationBalloonId}`,
    );
  },
  addOfl: (data: IAddTOflRequest) => {
    return axiosClient.post(`${API_URLS.ADD_OFL}`, data);
  },

  getBreakfastDetails: (operationDate: string, ownerId: number) => {
    return axiosClient.get(
      `${API_URLS.BREAKFAST_DATA}?operationDate=${operationDate}&ownerId=${ownerId}`,
    );
  },

  getPaymentBreakupDetails: (toDate: string, ownerId: number) => {
    return axiosClient.get(
      `${API_URLS.PAYMENT_BREAKUP}?toDate=${toDate}&ownerId=${ownerId}`,
    );
  },
  getCountriesPaxDetails: (date: string, ownerId: number) => {
    return axiosClient.get(
      `${API_URLS.COUNTRY_PAX_COUNT}?date=${date}&ownerId=${ownerId}`,
    );
  },

  getFlightsDetails: (date: string, ownerId: number) => {
    return axiosClient.get(
      `${API_URLS.OPS_FLIGHT_DETAILS}?date=${date}&ownerId=${ownerId}`,
    );
  },

  getWeatherDetails: (date: string, ownerId: number) => {
    return axiosClient.get(
      `${API_URLS.WEATHER_DETAILS}?date=${date}&ownerId=${ownerId}`,
    );
  },

  getCancelreasonDetails: () => {
    return axiosClient.get(`${API_URLS.CANCEL_REASON_DETAILS}`);
  },

  getCancelFlight: (data: ICancelFlight) => {
    return axiosClient.put(`${API_URLS.CANCEL_FLIGHT}`, data);
  },

  updateFlight: (data: EditFlightForm) => {
    return axiosClient.put(`${API_URLS.UPDATE_FLIGHT}`, data);
  },

  getForcastOptions: () => {
    return axiosClient.get(`${API_URLS.FORCAST_OPTIONS}`);
  },

  getForcastTravelStatus: (
    fromDate: string,
    toDate: string,
    ownerId: number,
  ) => {
    return axiosClient.get(
      `${API_URLS.FORCAST_TRAVEL_STATUS}?fromDate=${fromDate}&toDate=${toDate}&ownerId=${ownerId}`,
    );
  },

  updateForcastTravel: (requestBody: IOperationsForecastRequest) => {
    return axiosClient.put(`${API_URLS.FORCAST_TRAVEL_STATUS}`, requestBody);
  },

  updateWeatherDetails: (data: IFLightWeatherInfo) => {
    return axiosClient.put(`${API_URLS.WEATHER_DETAILS}`, data);
  },

  updateComments: (data: IUpdateComments) => {
    return axiosClient.put(`${API_URLS.UPDATE_COMMENTS}`, data);
  },

  reactivateFlightCancellation: (data: IFlightCancelReactivateRequest) => {
    return axiosClient.put(`${API_URLS.REACTIVATE_FLIGHT_CANCEL}`, data);
  },

  getBookingRate: (date: string, ownerId: number, rate: number) => {
    return axiosClient.get(
      `${API_URLS.BOOKING_RATE}?date=${date}&ownerId=${ownerId}&rate=${rate}`,
    );
  },
  getOperationCheckListDetails: (ownerId: number, date: string) => {
    return axiosClient.get(
      `${API_URLS?.OPERATION_CHECKLIST}?ownerId=${ownerId}&toDate=${date}`,
    );
  },
  getDriverAllocationList: (ownerId: number, encodedDate: string) => {
    return axiosClient.get(
      `${API_URLS.OPERATION_DRIVER_ALLOCATION_LIST}?ownerId=${ownerId}&fromDate=${encodedDate}`,
    );
  },

  getCrewAllocationList: (ownerId: number, encodedDate: string) => {
    return axiosClient.get(
      `${API_URLS.OPERATION_CREW_ALLOCATION_LIST}?ownerId=${ownerId}&fromDate=${encodedDate}`,
    );
  },

  getPilotAllocationList: (ownerId: number, encodedDate: string) => {
    return axiosClient.get(
      `${API_URLS.OPERATION_PILOT_ALLOCATION_LIST}?ownerId=${ownerId}&fromDate=${encodedDate}`,
    );
  },

  addRes: (data: IUpdateResPhone) => {
    return axiosClient.put(API_URLS.ADD_RES, data);
  },

  getTempList: () => {
    return axiosClient.get(`${API_URLS.TEMP_LIST}`);
  },
  getTodaysTemp: (ownerId: number, date: string) => {
    return axiosClient.get(
      `${API_URLS.TODAYS_TEMP}?ownerId=${ownerId}&date=${date}`,
    );
  },
};

export default operationAPI;
